import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Text } from '../../Text';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The label to be shown next to the badge */
  label?: ReactNode;
  /** The sub label shown below the label */
  subLabel?: ReactNode;
  /** The number to be shown in the badge */
  value: number;
  /** The ID of the Score Rating value */
  scoreId?: string;
  /** The ID of the Label text i.e. Superb/Good */
  scoreLabelId?: string;
  /** The ID of the SubLabel which is review count  */
  scoreSubLabelId?: string;
}
const RatingElement = /*#__PURE__*/styled('div')({
  name: "RatingElement",
  class: "rwl6737",
  propsAsIs: false
});
const BadgeWrapper = /*#__PURE__*/styled('div')({
  name: "BadgeWrapper",
  class: "b1663nrl",
  propsAsIs: false
});
const LabelWrapper = /*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "lvp743i",
  propsAsIs: false
});
const _exp14 = /*#__PURE__*/() => Text;
const LabelText = /*#__PURE__*/styled(_exp14())({
  name: "LabelText",
  class: "lphufbp",
  propsAsIs: true
});
const _exp16 = /*#__PURE__*/() => Text;
const SubLabelText = /*#__PURE__*/styled(_exp16())({
  name: "SubLabelText",
  class: "s17p4uca",
  propsAsIs: true
});
export const ScoreRatingLarge = ({
  label,
  subLabel,
  value,
  className,
  scoreId,
  scoreLabelId,
  scoreSubLabelId
}: Props) => <RatingElement className={cx(value >= 7 && '--high', value < 7 && '--poor', className)}>
    <BadgeWrapper id={scoreId}>{value || '-'}</BadgeWrapper>
    {(label || subLabel) && <LabelWrapper>
        {label && <LabelText id={scoreLabelId} variant="titleL">
            {label}
          </LabelText>}
        {subLabel && <SubLabelText variant="bodyXS" id={scoreSubLabelId}>
            {subLabel}
          </SubLabelText>}
      </LabelWrapper>}
  </RatingElement>;

require("./ScoreRatingLarge.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ScoreRatingLarge.tsx");